import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    imports: [
        CommonModule,
        IconSharedModule
    ],
    declarations: [AccordionComponent],
    exports: [AccordionComponent]
})
export class AccordionSharedModule {
}
